import { render, staticRenderFns } from "./StockInventory.vue?vue&type=template&id=99764770&"
import script from "./StockInventory.vue?vue&type=script&lang=js&"
export * from "./StockInventory.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports